import { z } from "zod";

export const companionSchema = z.object({
    idUUID: z.string(),
});
